import { FC } from 'react';
import { useQueryState } from 'nuqs';

import {
    getSearchFilterActiveCount,
    searchFiltersQuery,
    SearchFiltersSider,
    unwrapSearchFilters,
    type SearchFilterChangeHandler,
} from '@/shared';

import FilterOptions from './views/01-FilterOptions';
import SavedFilters from './views/02-CustomFilters';

interface SiderProps {
    filters: unknown;
    handleChange: SearchFilterChangeHandler;
}

const Sider: FC<SiderProps> = ({ filters, handleChange }): JSX.Element => {
    const [, setFilters] = useQueryState('filters', searchFiltersQuery);
    const legacyFilters = unwrapSearchFilters(filters);

    return (
        <SearchFiltersSider
            activeFilterCount={getSearchFilterActiveCount(legacyFilters)}
            filters={filters}
            filtersView={<FilterOptions filters={legacyFilters} handleChange={handleChange} />}
            onSaveSuccess={async () => {
                await setFilters(null);
            }}
            savedFiltersView={<SavedFilters />}
        />
    );
};

export default Sider;
